import React from "react";

const SelectedRadioIcon = ({
  size = 16,
  className = "text-background-white",
}) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"
        />
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          d="M7.999 10.666a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"
        />
      </svg>
    </span>
  );
};

export const UnselectedRadioIcon = ({
  size = 16,
  className = "text-primary",
}) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <g clipPath="url(#clip0_16791_259549)">
          <path
            stroke="#085054"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7.999 14.666a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333"
          />
        </g>
        <defs>
          <clipPath id="clip0_16791_259549">
            <path fill="#fff" d="M0 0h16v16H0z" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default SelectedRadioIcon;
